import React from "react";
import PropTypes from "prop-types";

export class ValidationErrors extends React.Component {
    render() {
        const { errors } = this.props;
        if (!errors.length) {
            return null;
        }
        return (
            <div className="validation-errors">
                {errors.map((error, index) => (
                    <div key={index} className="validation-errors__error">
                        {error}
                    </div>
                ))}
            </div>
        );
    }
}

ValidationErrors.propTypes = {
    errors: PropTypes.arrayOf(PropTypes.string)
};

ValidationErrors.defaultProps = {
    errors: []
};
